import RefertazioneEcocardioEdit from "./components/RefertazioneEcocardioEdit.vue";
import RefertazioneEcocardioView from "./components/RefertazioneEcocardioView.vue";
import RefertazioneEcocardioList from "./components/RefertazioneEcocardioList.vue";

export default {
    RefertazioneEcocardioEdit,
    RefertazioneEcocardioView,
    RefertazioneEcocardioList,
};
